import { useRef } from 'react';

import type { FormikProps } from 'formik';
import { Form } from 'formik';

import Button from 'src/app/components/Elements/Button';
import { Card, CardItem } from 'src/app/components/Elements/Card';
import GenericError from 'src/app/components/Error/Generic';
import { SegmentFormIncomplete } from 'src/app/components/Error/SegmentFormIncomplete';
import TextInput from 'src/app/components/Form/TextInput';
import PhoneTextInput from 'src/app/components/Form/TextInput/Phone';

import type { PropsFromRedux } from './container';
import { ButtonSection, ContactInfoHeader, ContentContainer, HeaderContainer } from './styles';
import type { IntialValues } from './validation';

export const CheckoutContactInfoRenderer = ({ isValid, isSubmitting }: PropsFromRedux & FormikProps<IntialValues>) => {
  const formRef = useRef<HTMLFormElement | null>(null);

  return (
    <>
      <ContentContainer>
        <HeaderContainer>
          <ContactInfoHeader>Add your contact info</ContactInfoHeader>
        </HeaderContainer>
      </ContentContainer>
      <Card>
        <CardItem>
          <Form ref={formRef}>
            <GenericError />
            <SegmentFormIncomplete />
            <>
              <TextInput name="first_name" type="text" label="First Name" />
              <TextInput name="last_name" type="text" label="Last Name" />
              <PhoneTextInput name="phone" label="Mobile Number" helperText="We'll text you about your order." />
            </>
            <ButtonSection>
              <Button
                data-cy={'checkoutContactInfoButton'}
                type="submit"
                size="medium"
                style="secondary"
                block
                disabled={isSubmitting || !isValid}
              >
                Save
              </Button>
            </ButtonSection>
          </Form>
        </CardItem>
      </Card>
    </>
  );
};
